module.exports = __webpack_public_path__ + "img/aygaz-conversion-club-infographic-05.266eabec.jpg";